export default __webpack_public_path__ + "static/media/RedSea.44c02387.jpeg";